import { connect } from 'react-redux'

import { removeAllMessages, removeMessage, setErrorMessage, setSuccessMessage } from './reducer'

const mapStateToProps = (state) => {
    return {
        messagesList: state?.components?.windowMessage?.messages ?? [],
    }
}

const mapDispatchToProps = { setErrorMessage, setSuccessMessage, removeMessage, removeAllMessages }

const hocWindowMessage = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocWindowMessage
